import * as React from "react";

export const CircleIcon = ({ isActive, opacity, ...props }: SvgIconProps) => {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M7.667 14.333A6.667 6.667 0 107.667 1a6.667 6.667 0 000 13.333z"
        stroke={isActive ? "#01A8CE" : "#214160"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.667 11.666a4 4 0 100-8 4 4 0 000 8z"
        stroke={isActive ? "#01A8CE" : "#214160"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.667 9a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667z"
        stroke={isActive ? "#01A8CE" : "#214160"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
